import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglassHalf } from "@fortawesome/free-solid-svg-icons";

/**
 * กล่อง "เร็วๆ นี้" สำหรับหน้าที่ยังไม่มีข้อมูล
 * ใช้ในหน้าที่มีหัวเรื่องของตัวเองอยู่แล้ว (เช่น Infographic ตอนยังไม่มีรายการ)
 */
export function ComingSoonBox({ lang }) {
  const history = useHistory();
  const t = (th, en) => (lang === "en" ? en : th);

  return (
    <div className="flex flex-col items-center text-center py-[56px] sm:py-[80px]">
      <FontAwesomeIcon icon={faHourglassHalf} className="text-blue text-[40px] sm:text-[48px]" />
      <h2 className="text-heading font-bold text-slateGray mt-[24px]">
        {t("เร็วๆ นี้", "Coming soon")}
      </h2>
      <p className="text-meta sm:text-body text-metaGray mt-[10px] max-w-[560px]">
        {t(
          "หน้านี้อยู่ระหว่างจัดเตรียมข้อมูล กรุณากลับมาใหม่อีกครั้ง",
          "We are preparing the content for this page. Please check back soon."
        )}
      </p>
      <button
        type="button"
        onClick={() => history.push(`/${lang === "en" ? "en" : "th"}`)}
        className="rounded-[6px] bg-brand text-white text-body font-bold px-[40px] py-[12px] mt-[28px] hover:opacity-90"
      >
        {t("กลับสู่หน้าหลัก", "Back to home")}
      </button>
    </div>
  );
}

/**
 * หน้า "เร็วๆ นี้" แบบเต็มหน้า
 * ใช้กับลิงก์ที่ยังไม่มีหน้า (เมนูที่แอดมินเพิ่มไว้ก่อน) และบริการที่ยังไม่มีข้อมูล
 * แทนการเด้งกลับหน้าแรก ซึ่งทำให้คนกดงงว่าเมนูเสีย
 */
export default function ComingSoon() {
  const { lang } = useParams();

  useEffect(() => {
    if (lang !== "th" && lang !== "en") window.open("/th", "_self");
    window.scrollTo(0, 0);
  }, [lang]);

  return (
    <div className="pt-[135px] lg:pt-[0px]">
      <div className="section">
        <div className="page-container">
          <div className="mt-[64px] sm:mt-[92px] mb-[160px] sm:mb-[300px]">
            <ComingSoonBox lang={lang} />
          </div>
        </div>
      </div>
    </div>
  );
}
